import { api } from "@/api/api";

export const Youtube = {
    state: {
        youtubeList: [],
    },
    getters: {
        getYoutubeList(state) {
            return state.youtubeList;
        },
    },
    mutations: {
        setYoutubeList(state, payload) {
            state.youtubeList = payload;
        },
    },
    actions: {
        async getYoutubeList({ commit }) {
            await api.youtube
                .getYoutubeList()
                .then((res) => {
                    commit("setYoutubeList", res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async addYoutube({ dispatch }, args) {
            await api.youtube
                .addYoutube(args)
                .then(() => {
                    dispatch("getYoutubeList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },

        async deleteYoutube({ dispatch }, args) {
            await api.youtube
                .deleteYoutube(args)
                .then(() => {
                    dispatch("getYoutubeList");
                })
                .catch((err) => {
                    console.log(err);
                });
            return Promise.resolve();
        },
    },
};
